const noDataStyle = {
    width: '100%',
    height: '100%',
    fontSize: '18px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'gray'
}

const NoData = () => {
    return <div style={noDataStyle}>
        暂无数据
    </div>
}

export default NoData;
